import axios from 'axios';
import Config from '@/config';
import { Token } from '@/api/token';

const baseUrl = `${Config.BaseAPI}/v3`;

export default {
  authenticateConcierge: async function(form) {
    const url = `${baseUrl}/auth/concierge`;
    const token = await Token.getToken();

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const body = {
      email: form.email,
      authMethod: 'email',
      password: form.password
    };

    const result = await axios.post(url, body, { headers });
    return result.data.record;
  },

  changePassword: async function(form) {
    const url = `${baseUrl}/password`;
    const token = await Token.getToken();
    const { loginAccessToken } = await Token.getConciergeSession();

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const body = {
      accessToken: loginAccessToken,
      oldPassword: form.currentPassword,
      newPassword: form.newPassword
    };

    const result = await axios.patch(url, body, { headers });
    return result.data.record;
  },

  logoutConcierge: function() {
    localStorage.token = null;
    localStorage.conciergeId = null;
    localStorage.session = null;
  }
};
